import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@popperjs/core";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { CookiesProvider } from "react-cookie";
import reportWebVitals from "./reportWebVitals";
import "react-tooltip/dist/react-tooltip.css";
import { getFormContainersAndVersions } from "./components/services/soar";

//////////////////////////////////////////////////////////////////////////////////
//new azure authentication implementation

import {
  PublicClientApplication,
  EventType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { msalConfig, loginRequest, graphConfig } from "./authConfig";
import { callMsGraph } from "./components/services/MSGraphApiCall";

export const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

// msalInstance
//   .handleRedirectPromise()
//   .then((tokenResponse) => {
//     console.log("MSAL TESTING REDIRECT RESPONSE", tokenResponse);
//     // Handle redirect response
//     msalInstance.setActiveAccount(tokenResponse.account);
//     loadContainersVersions();
//     callMsGraph(graphConfig.graphMeEndpoint).catch((e) => {
//       if (e instanceof InteractionRequiredAuthError) {
//         msalInstance.acquireTokenRedirect({
//           ...loginRequest,
//           account: tokenResponse.account,
//         });
//       }
//     });
//   })
//   .catch((error) => {
//     // Handle redirect error
//   });

msalInstance.addEventCallback(async (event) => {
  // console.log("MSAL EVENT", event);
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    console.log("MSAL: Index.js Login Success", event);
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
    //HANDLE WHO AM I HERE??
    await callMsGraph(graphConfig.graphMeEndpoint).catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          ...loginRequest,
          account: account,
        });
      }
    });

    await loadContainersVersions();
  }
});

const loadContainersVersions = async () => {
  try {
    const allForms = await getFormContainersAndVersions();
    localStorage.setItem("formContainersVersions", JSON.stringify(allForms));
    console.log("AppJS - Setting Forms and Containers");
  } catch (error) {
    console.error("Error loading form containers and versions:", error);
  }
};
//////////////////////////////////////////////////////////////////////////////////
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <CookiesProvider>
    <Router>
      <App pca={msalInstance} />
    </Router>
  </CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
